import React, { PropsWithChildren } from 'react'
import { sheetFooterCss } from './SheetFooter.css'

interface Props {
  children: PropsWithChildren<any>
}

export default function SheetFooter(props: Props) {
  return (
    <div className={sheetFooterCss} data-testid="sheet-footer">
      {props.children}
    </div>
  )
}
